// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"241":"swaps","296":"privacy","480":"disclaimer","609":"bridge","720":"faq","929":"terms"}[chunkId] || chunkId) + "." + {"241":"d1e699f7","296":"3941ec4b","480":"acb31485","609":"884723b0","615":"d22d8d7e","685":"4cc39bb5","720":"44600dea","929":"86a226e3"}[chunkId] + ".js";
};